function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n2 = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n2 >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n2++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var re = Object.defineProperty;
var ne = function ne(l, a, e) {
  return a in l ? re(l, a, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : l[a] = e;
};
var m = function m(l, a, e) {
  return ne(l, _typeof(a) != "symbol" ? a + "" : a, e);
};
import { Plugin as _ } from "../../../../../@ckeditor_ckeditor5-core@45.1.0/node_modules/@ckeditor/ckeditor5-core/dist/index.js";
import { EventInfo as j, uid as H, delay as K, DomEmitterMixin as S, env as b, global as f, createElement as B, Rect as k, getRangeFromMouseEvent as ie, ResizeObserver as oe, toUnit as se } from "../../../../../@ckeditor_ckeditor5-utils@45.1.0/node_modules/@ckeditor/ckeditor5-utils/dist/index.js";
import { MouseObserver as ae, LiveRange as w, DomEventObserver as le, DataTransfer as ce, Range as de } from "../../../../../@ckeditor_ckeditor5-engine@45.1.0/node_modules/@ckeditor/ckeditor5-engine/dist/index.js";
import { Widget as ge, isWidget as y } from "../../../../../@ckeditor_ckeditor5-widget@45.1.0/node_modules/@ckeditor/ckeditor5-widget/dist/index.js";
import { View as pe } from "../../../../../@ckeditor_ckeditor5-ui@45.1.0/node_modules/@ckeditor/ckeditor5-ui/dist/index.js";
import { mapValues as me } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/mapValues.js";
import { throttle as L } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/function/throttle.js"; /**
                                                                                                                           * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                           * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                           */
var D = /*#__PURE__*/function (_le) {
  function D(e) {
    var _this;
    _classCallCheck(this, D);
    _this = _callSuper(this, D, [e]);
    m(_this, "domEventType", ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"]);
    var n = _this.document;
    _this.listenTo(n, "paste", t("clipboardInput"), {
      priority: "low"
    }), _this.listenTo(n, "drop", t("clipboardInput"), {
      priority: "low"
    }), _this.listenTo(n, "dragover", t("dragging"), {
      priority: "low"
    });
    function t(i) {
      return function (o, r) {
        r.preventDefault();
        var s = r.dropRange ? [r.dropRange] : null,
          c = new j(n, i);
        n.fire(c, {
          dataTransfer: r.dataTransfer,
          method: o.name,
          targetRanges: s,
          target: r.target,
          domEvent: r.domEvent
        }), c.stop.called && r.stopPropagation();
      };
    }
    return _this;
  }
  _inherits(D, _le);
  return _createClass(D, [{
    key: "onDomEvent",
    value: function onDomEvent(e) {
      var n = "clipboardData" in e ? e.clipboardData : e.dataTransfer,
        t = e.type == "drop" || e.type == "paste",
        i = {
          dataTransfer: new ce(n, {
            cacheFiles: t
          })
        };
      if (e.type == "drop" || e.type == "dragover") {
        var o = ie(e);
        i.dropRange = o && this.view.domConverter.domRangeToView(o);
      }
      this.fire(e.type, e, i);
    }
  }]);
}(le);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function ue(l) {
  return l = l.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;"), (l.includes("</p><p>") || l.includes("<br>")) && (l = "<p>".concat(l, "</p>")), l;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function he(l) {
  return l.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (a, e) {
    return e.length == 1 ? " " : e;
  }).replace(/<!--[\s\S]*?-->/g, "");
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
var U = ["figcaption", "li"],
  $ = ["ol", "ul"];
function G(l, a) {
  if (a.is("$text") || a.is("$textProxy")) return a.data;
  if (a.is("element", "img") && a.hasAttribute("alt")) return a.getAttribute("alt");
  if (a.is("element", "br")) return "\n";
  var e = "",
    n = null;
  var _iterator = _createForOfIteratorHelper(a.getChildren()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _t = _step.value;
      e += fe(_t, n) + G(l, _t), n = _t;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (a.is("rawElement")) {
    var t = document.createElement("div");
    a.render(t, l), e += X(t);
  }
  return e;
}
function X(l) {
  var a = "";
  if (l.nodeType === Node.TEXT_NODE) return l.textContent;
  if (l.tagName === "BR") return "\n";
  var _iterator2 = _createForOfIteratorHelper(l.childNodes),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var e = _step2.value;
      a += X(e);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return a;
}
function fe(l, a) {
  return a ? l.is("element", "li") && !l.isEmpty && l.getChild(0).is("containerElement") || $.includes(l.name) && $.includes(a.name) ? "\n\n" : !l.is("containerElement") && !a.is("containerElement") ? "" : U.includes(l.name) || U.includes(a.name) ? "\n" : l.is("element") && l.getCustomProperty("dataPipeline:transparentRendering") || a.is("element") && a.getCustomProperty("dataPipeline:transparentRendering") ? "" : "\n\n" : "";
}
var Y = /*#__PURE__*/function (_ref) {
  function Y() {
    var _this2;
    _classCallCheck(this, Y);
    _this2 = _callSuper(this, Y, arguments);
    m(_this2, "_markersToCopy", new Map());
    return _this2;
  }
  _inherits(Y, _ref);
  return _createClass(Y, [{
    key: "_registerMarkerToCopy",
    value: function _registerMarkerToCopy(e, n) {
      this._markersToCopy.set(e, n);
    }
  }, {
    key: "_copySelectedFragmentWithMarkers",
    value: function _copySelectedFragmentWithMarkers(e, n) {
      var _this3 = this;
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (i) {
        return i.model.getSelectedContent(i.model.document.selection);
      };
      return this.editor.model.change(function (i) {
        var o = i.model.document.selection;
        i.setSelection(n);
        var r = _this3._insertFakeMarkersIntoSelection(i, i.model.document.selection, e),
          s = t(i),
          c = _this3._removeFakeMarkersInsideElement(i, s);
        for (var _i = 0, _Object$entries = Object.entries(r); _i < _Object$entries.length; _i++) {
          var _ref2 = _Object$entries[_i];
          var _ref3 = _slicedToArray(_ref2, 2);
          var d = _ref3[0];
          var g = _ref3[1];
          c[d] || (c[d] = i.createRangeIn(s));
          var _iterator3 = _createForOfIteratorHelper(g),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var p = _step3.value;
              i.remove(p);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
        s.markers.clear();
        for (var _i2 = 0, _Object$entries2 = Object.entries(c); _i2 < _Object$entries2.length; _i2++) {
          var _ref4 = _Object$entries2[_i2];
          var _ref5 = _slicedToArray(_ref4, 2);
          var _d = _ref5[0];
          var _g = _ref5[1];
          s.markers.set(_d, _g);
        }
        return i.setSelection(o), s;
      });
    }
  }, {
    key: "_pasteMarkersIntoTransformedElement",
    value: function _pasteMarkersIntoTransformedElement(e, n) {
      var _this4 = this;
      var t = this._getPasteMarkersFromRangeMap(e);
      return this.editor.model.change(function (i) {
        var o = _this4._insertFakeMarkersElements(i, t),
          r = n(i),
          s = _this4._removeFakeMarkersInsideElement(i, r);
        var _iterator4 = _createForOfIteratorHelper(Object.values(o).flat()),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _c = _step4.value;
            i.remove(_c);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        for (var _i3 = 0, _Object$entries3 = Object.entries(s); _i3 < _Object$entries3.length; _i3++) {
          var _ref6 = _Object$entries3[_i3];
          var _ref7 = _slicedToArray(_ref6, 2);
          var c = _ref7[0];
          var d = _ref7[1];
          i.model.markers.has(c) || i.addMarker(c, {
            usingOperation: !0,
            affectsData: !0,
            range: d
          });
        }
        return r;
      });
    }
  }, {
    key: "_pasteFragmentWithMarkers",
    value: function _pasteFragmentWithMarkers(e) {
      var n = this._getPasteMarkersFromRangeMap(e.markers);
      e.markers.clear();
      var _iterator5 = _createForOfIteratorHelper(n),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var t = _step5.value;
          e.markers.set(t.name, t.range);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return this.editor.model.insertContent(e);
    }
  }, {
    key: "_forceMarkersCopy",
    value: function _forceMarkersCopy(e, n) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        allowedActions: "all",
        copyPartiallySelected: !0,
        duplicateOnPaste: !0
      };
      var i = this._markersToCopy.get(e);
      this._markersToCopy.set(e, t), n(), i ? this._markersToCopy.set(e, i) : this._markersToCopy.delete(e);
    }
  }, {
    key: "_isMarkerCopyable",
    value: function _isMarkerCopyable(e, n) {
      var t = this._getMarkerClipboardConfig(e);
      if (!t) return !1;
      if (!n) return !0;
      var i = t.allowedActions;
      return i === "all" || i.includes(n);
    }
  }, {
    key: "_hasMarkerConfiguration",
    value: function _hasMarkerConfiguration(e) {
      return !!this._getMarkerClipboardConfig(e);
    }
  }, {
    key: "_getMarkerClipboardConfig",
    value: function _getMarkerClipboardConfig(e) {
      var _e$split = e.split(":"),
        _e$split2 = _slicedToArray(_e$split, 1),
        n = _e$split2[0];
      return this._markersToCopy.get(n) || null;
    }
  }, {
    key: "_insertFakeMarkersIntoSelection",
    value: function _insertFakeMarkersIntoSelection(e, n, t) {
      var i = this._getCopyableMarkersFromSelection(e, n, t);
      return this._insertFakeMarkersElements(e, i);
    }
  }, {
    key: "_getCopyableMarkersFromSelection",
    value: function _getCopyableMarkersFromSelection(e, n, t) {
      var _this5 = this;
      var i = Array.from(n.getRanges()),
        o = new Set(i.flatMap(function (s) {
          return Array.from(e.model.markers.getMarkersIntersectingRange(s));
        })),
        r = function r(s) {
          if (!_this5._isMarkerCopyable(s.name, t)) return !1;
          var _this5$_getMarkerClip = _this5._getMarkerClipboardConfig(s.name),
            d = _this5$_getMarkerClip.copyPartiallySelected;
          if (!d) {
            var g = s.getRange();
            return i.some(function (p) {
              return p.containsRange(g, !0);
            });
          }
          return !0;
        };
      return Array.from(o).filter(r).map(function (s) {
        return {
          name: t === "dragstart" ? _this5._getUniqueMarkerName(s.name) : s.name,
          range: s.getRange()
        };
      });
    }
  }, {
    key: "_getPasteMarkersFromRangeMap",
    value: function _getPasteMarkersFromRangeMap(e) {
      var _this6 = this;
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var t = this.editor.model;
      return (e instanceof Map ? Array.from(e.entries()) : Object.entries(e)).flatMap(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
          o = _ref9[0],
          r = _ref9[1];
        if (!_this6._hasMarkerConfiguration(o)) return [{
          name: o,
          range: r
        }];
        if (_this6._isMarkerCopyable(o, n)) {
          var s = _this6._getMarkerClipboardConfig(o),
            c = t.markers.has(o) && t.markers.get(o).getRange().root.rootName === "$graveyard";
          return (s.duplicateOnPaste || c) && (o = _this6._getUniqueMarkerName(o)), [{
            name: o,
            range: r
          }];
        }
        return [];
      });
    }
  }, {
    key: "_insertFakeMarkersElements",
    value: function _insertFakeMarkersElements(e, n) {
      var t = {},
        i = n.flatMap(function (o) {
          var _o$range = o.range,
            r = _o$range.start,
            s = _o$range.end;
          return [{
            position: r,
            marker: o,
            type: "start"
          }, {
            position: s,
            marker: o,
            type: "end"
          }];
        }).sort(function (_ref0, _ref1) {
          var o = _ref0.position;
          var r = _ref1.position;
          return o.isBefore(r) ? 1 : -1;
        });
      var _iterator6 = _createForOfIteratorHelper(i),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref10 = _step6.value;
          var o = _ref10.position;
          var r = _ref10.marker;
          var s = _ref10.type;
          var c = e.createElement("$marker", {
            "data-name": r.name,
            "data-type": s
          });
          t[r.name] || (t[r.name] = []), t[r.name].push(c), e.insert(c, o);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return t;
    }
  }, {
    key: "_removeFakeMarkersInsideElement",
    value: function _removeFakeMarkersInsideElement(e, n) {
      var _this7 = this;
      var i = this._getAllFakeMarkersFromElement(e, n).reduce(function (o, r) {
        var s = r.markerElement && e.createPositionBefore(r.markerElement);
        var c = o[r.name],
          d = !1;
        return c != null && c.start && c != null && c.end && (_this7._getMarkerClipboardConfig(r.name).duplicateOnPaste ? o[_this7._getUniqueMarkerName(r.name)] = o[r.name] : d = !0, c = null), d || (o[r.name] = _objectSpread(_objectSpread({}, c), {}, _defineProperty({}, r.type, s))), r.markerElement && e.remove(r.markerElement), o;
      }, {});
      return me(i, function (o) {
        return new de(o.start || e.createPositionFromPath(n, [0]), o.end || e.createPositionAt(n, "end"));
      });
    }
  }, {
    key: "_getAllFakeMarkersFromElement",
    value: function _getAllFakeMarkersFromElement(e, n) {
      var t = Array.from(e.createRangeIn(n)).flatMap(function (_ref11) {
          var r = _ref11.item;
          if (!r.is("element", "$marker")) return [];
          var s = r.getAttribute("data-name"),
            c = r.getAttribute("data-type");
          return [{
            markerElement: r,
            name: s,
            type: c
          }];
        }),
        i = [],
        o = [];
      var _iterator7 = _createForOfIteratorHelper(t),
        _step7;
      try {
        var _loop = function _loop() {
          var r = _step7.value;
          r.type === "end" && (t.some(function (c) {
            return c.name === r.name && c.type === "start";
          }) || i.push({
            markerElement: null,
            name: r.name,
            type: "start"
          })), r.type === "start" && (t.some(function (c) {
            return c.name === r.name && c.type === "end";
          }) || o.unshift({
            markerElement: null,
            name: r.name,
            type: "end"
          }));
        };
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return [].concat(i, _toConsumableArray(t), o);
    }
  }, {
    key: "_getUniqueMarkerName",
    value: function _getUniqueMarkerName(e) {
      var n = e.split(":"),
        t = H().substring(1, 6);
      return n.length === 3 ? "".concat(n.slice(0, 2).join(":"), ":").concat(t) : "".concat(n.join(":"), ":").concat(t);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ClipboardMarkersUtils";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(_);
var T = /*#__PURE__*/function (_ref12) {
  function T() {
    _classCallCheck(this, T);
    return _callSuper(this, T, arguments);
  }
  _inherits(T, _ref12);
  return _createClass(T, [{
    key: "init",
    value: function init() {
      this.editor.editing.view.addObserver(D), this._setupPasteDrop(), this._setupCopyCut();
    }
  }, {
    key: "_fireOutputTransformationEvent",
    value: function _fireOutputTransformationEvent(a, e, n) {
      var _this8 = this;
      var t = this.editor.plugins.get("ClipboardMarkersUtils");
      this.editor.model.enqueueChange({
        isUndoable: n === "cut"
      }, function () {
        var i = t._copySelectedFragmentWithMarkers(n, e);
        _this8.fire("outputTransformation", {
          dataTransfer: a,
          content: i,
          method: n
        });
      });
    }
  }, {
    key: "_setupPasteDrop",
    value: function _setupPasteDrop() {
      var _this9 = this;
      var a = this.editor,
        e = a.model,
        n = a.editing.view,
        t = n.document,
        i = this.editor.plugins.get("ClipboardMarkersUtils");
      this.listenTo(t, "clipboardInput", function (o, r) {
        r.method == "paste" && !a.model.canEditAt(a.model.document.selection) && o.stop();
      }, {
        priority: "highest"
      }), this.listenTo(t, "clipboardInput", function (o, r) {
        var s = r.dataTransfer;
        var c;
        if (r.content) c = r.content;else {
          var p = "";
          s.getData("text/html") ? p = he(s.getData("text/html")) : s.getData("text/plain") && (p = ue(s.getData("text/plain"))), c = _this9.editor.data.htmlProcessor.toView(p);
        }
        var d = new j(_this9, "inputTransformation"),
          g = s.getData("application/ckeditor5-editor-id") || null;
        _this9.fire(d, {
          content: c,
          dataTransfer: s,
          sourceEditorId: g,
          targetRanges: r.targetRanges,
          method: r.method
        }), d.stop.called && o.stop(), n.scrollToTheSelection();
      }, {
        priority: "low"
      }), this.listenTo(this, "inputTransformation", function (o, r) {
        if (r.content.isEmpty) return;
        var c = _this9.editor.data.toModel(r.content, "$clipboardHolder");
        c.childCount != 0 && (o.stop(), e.change(function () {
          _this9.fire("contentInsertion", {
            content: c,
            method: r.method,
            sourceEditorId: r.sourceEditorId,
            dataTransfer: r.dataTransfer,
            targetRanges: r.targetRanges
          });
        }));
      }, {
        priority: "low"
      }), this.listenTo(this, "contentInsertion", function (o, r) {
        r.resultRange = i._pasteFragmentWithMarkers(r.content);
      }, {
        priority: "low"
      });
    }
  }, {
    key: "_setupCopyCut",
    value: function _setupCopyCut() {
      var _this0 = this;
      var a = this.editor,
        e = a.model.document,
        t = a.editing.view.document,
        i = function i(o, r) {
          var s = r.dataTransfer;
          r.preventDefault(), _this0._fireOutputTransformationEvent(s, e.selection, o.name);
        };
      this.listenTo(t, "copy", i, {
        priority: "low"
      }), this.listenTo(t, "cut", function (o, r) {
        a.model.canEditAt(a.model.document.selection) ? i(o, r) : r.preventDefault();
      }, {
        priority: "low"
      }), this.listenTo(this, "outputTransformation", function (o, r) {
        var s = a.data.toView(r.content, {
          isClipboardPipeline: !0
        });
        t.fire("clipboardOutput", {
          dataTransfer: r.dataTransfer,
          content: s,
          method: r.method
        });
      }, {
        priority: "low"
      }), this.listenTo(t, "clipboardOutput", function (o, r) {
        r.content.isEmpty || (r.dataTransfer.setData("text/html", _this0.editor.data.htmlProcessor.toData(r.content)), r.dataTransfer.setData("text/plain", G(a.data.htmlProcessor.domConverter, r.content)), r.dataTransfer.setData("application/ckeditor5-editor-id", _this0.editor.id)), r.method == "cut" && a.model.deleteContent(e.selection);
      }, {
        priority: "low"
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ClipboardPipeline";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [Y];
    }
  }]);
}(_);
var A = se("px");
var be = /*#__PURE__*/function (_pe) {
  function be() {
    var _this1;
    _classCallCheck(this, be);
    _this1 = _callSuper(this, be);
    var a = _this1.bindTemplate;
    _this1.set({
      isVisible: !1,
      left: null,
      top: null,
      width: null
    }), _this1.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-clipboard-drop-target-line", a.if("isVisible", "ck-hidden", function (e) {
          return !e;
        })],
        style: {
          left: a.to("left", function (e) {
            return A(e);
          }),
          top: a.to("top", function (e) {
            return A(e);
          }),
          width: a.to("width", function (e) {
            return A(e);
          })
        }
      }
    });
    return _this1;
  }
  _inherits(be, _pe);
  return _createClass(be);
}(pe);
var C = /*#__PURE__*/function (_ref13) {
  function C() {
    var _this10;
    _classCallCheck(this, C);
    _this10 = _callSuper(this, C, arguments);
    m(_this10, "removeDropMarkerDelayed", K(function () {
      return _this10.removeDropMarker();
    }, 40));
    m(_this10, "_updateDropMarkerThrottled", L(function (e) {
      return _this10._updateDropMarker(e);
    }, 40));
    m(_this10, "_reconvertMarkerThrottled", L(function () {
      _this10.editor.model.markers.has("drop-target") && _this10.editor.editing.reconvertMarker("drop-target");
    }, 0));
    m(_this10, "_dropTargetLineView", new be());
    m(_this10, "_domEmitter", new (S())());
    m(_this10, "_scrollables", new Map());
    return _this10;
  }
  _inherits(C, _ref13);
  return _createClass(C, [{
    key: "init",
    value: function init() {
      this._setupDropMarker();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._domEmitter.stopListening();
      var _iterator8 = _createForOfIteratorHelper(this._scrollables.values()),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _ref14 = _step8.value;
          var e = _ref14.resizeObserver;
          e.destroy();
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return this._updateDropMarkerThrottled.cancel(), this.removeDropMarkerDelayed.cancel(), this._reconvertMarkerThrottled.cancel(), _superPropGet(C, "destroy", this, 3)([]);
    }
  }, {
    key: "updateDropMarker",
    value: function updateDropMarker(e, n, t, i, o, r) {
      this.removeDropMarkerDelayed.cancel();
      var s = N(this.editor, e, n, t, i, o, r); /* istanbul ignore next -- @preserve */
      if (s) {
        if (r && r.containsRange(s)) return this.removeDropMarker();
        this._updateDropMarkerThrottled(s);
      }
    }
  }, {
    key: "getFinalDropRange",
    value: function getFinalDropRange(e, n, t, i, o, r) {
      var s = N(this.editor, e, n, t, i, o, r);
      return this.removeDropMarker(), s;
    }
  }, {
    key: "removeDropMarker",
    value: function removeDropMarker() {
      var e = this.editor.model;
      this.removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), this._dropTargetLineView.isVisible = !1, e.markers.has("drop-target") && e.change(function (n) {
        n.removeMarker("drop-target");
      });
    }
  }, {
    key: "_setupDropMarker",
    value: function _setupDropMarker() {
      var _this11 = this;
      var e = this.editor;
      e.ui.view.body.add(this._dropTargetLineView), e.conversion.for("editingDowncast").markerToHighlight({
        model: "drop-target",
        view: {
          classes: ["ck-clipboard-drop-target-range"]
        }
      }), e.conversion.for("editingDowncast").markerToElement({
        model: "drop-target",
        view: function view(n, _ref15) {
          var t = _ref15.writer;
          if (e.model.schema.checkChild(n.markerRange.start, "$text")) return _this11._dropTargetLineView.isVisible = !1, _this11._createDropTargetPosition(t);
          n.markerRange.isCollapsed ? _this11._updateDropTargetLine(n.markerRange) : _this11._dropTargetLineView.isVisible = !1;
        }
      });
    }
  }, {
    key: "_updateDropMarker",
    value: function _updateDropMarker(e) {
      var n = this.editor,
        t = n.model.markers;
      n.model.change(function (i) {
        t.has("drop-target") ? t.get("drop-target").getRange().isEqual(e) || i.updateMarker("drop-target", {
          range: e
        }) : i.addMarker("drop-target", {
          range: e,
          usingOperation: !1,
          affectsData: !1
        });
      });
    }
  }, {
    key: "_createDropTargetPosition",
    value: function _createDropTargetPosition(e) {
      return e.createUIElement("span", {
        class: "ck ck-clipboard-drop-target-position"
      }, function (n) {
        var t = this.toDomElement(n);
        return t.append("⁠", n.createElement("span"), "⁠"), t;
      });
    }
  }, {
    key: "_updateDropTargetLine",
    value: function _updateDropTargetLine(e) {
      var n = this.editor.editing,
        t = e.start.nodeBefore,
        i = e.start.nodeAfter,
        o = e.start.parent,
        r = t ? n.mapper.toViewElement(t) : null,
        s = r ? n.view.domConverter.mapViewToDom(r) : null,
        c = i ? n.mapper.toViewElement(i) : null,
        d = c ? n.view.domConverter.mapViewToDom(c) : null,
        g = n.mapper.toViewElement(o);
      if (!g) return;
      var p = n.view.domConverter.mapViewToDom(g),
        h = this._getScrollableRect(g),
        _f$window = f.window,
        u = _f$window.scrollX,
        v = _f$window.scrollY,
        O = s ? new k(s) : null,
        I = d ? new k(d) : null,
        E = new k(p).excludeScrollbarsAndBorders(),
        F = O ? O.bottom : E.top,
        R = I ? I.top : E.bottom,
        x = f.window.getComputedStyle(p),
        P = F <= R ? (F + R) / 2 : R;
      if (h.top < P && P < h.bottom) {
        var Z = E.left + parseFloat(x.paddingLeft),
          ee = E.right - parseFloat(x.paddingRight),
          V = Math.max(Z + u, h.left),
          te = Math.min(ee + u, h.right);
        this._dropTargetLineView.set({
          isVisible: !0,
          left: V,
          top: P + v,
          width: te - V
        });
      } else this._dropTargetLineView.isVisible = !1;
    }
  }, {
    key: "_getScrollableRect",
    value: function _getScrollableRect(e) {
      var n = e.root.rootName;
      var t;
      if (this._scrollables.has(n)) t = this._scrollables.get(n).domElement;else {
        var i = this.editor.editing.view.domConverter.mapViewToDom(e);
        t = ke(i), this._domEmitter.listenTo(t, "scroll", this._reconvertMarkerThrottled, {
          usePassive: !0
        });
        var o = new oe(t, this._reconvertMarkerThrottled);
        this._scrollables.set(n, {
          domElement: t,
          resizeObserver: o
        });
      }
      return new k(t).excludeScrollbarsAndBorders();
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "DragDropTarget";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(_);
function N(l, a, e, n, t, i, o) {
  var r = l.model,
    s = l.editing.mapper;
  var d = W(l, a);
  var _loop2 = function _loop2() {
      if (!i) {
        if (r.schema.checkChild(d, "$text")) {
          if (e) {
            var g = e[0].start,
              p = s.toModelPosition(g);
            if (!o || Array.from(o.getItems({
              shallow: !0
            })).every(function (u) {
              return r.schema.checkChild(p, u);
            })) {
              if (r.schema.checkChild(p, "$text")) return {
                v: r.createRange(p)
              };
              if (g) return {
                v: M(l, W(l, g.parent), n, t)
              };
            }
          }
        } else if (r.schema.isInline(d)) return {
          v: M(l, d, n, t)
        };
      }
      if (r.schema.isBlock(d)) return {
        v: M(l, d, n, t)
      };
      if (r.schema.checkChild(d, "$block")) {
        var _g2 = Array.from(d.getChildren()).filter(function (u) {
          return u.is("element") && !_e(l, u);
        });
        var _p = 0,
          h = _g2.length;
        if (h == 0) return {
          v: r.createRange(r.createPositionAt(d, "end"))
        };
        for (; _p < h - 1;) {
          var u = Math.floor((_p + h) / 2);
          J(l, _g2[u], n, t) == "before" ? h = u : _p = u;
        }
        return {
          v: M(l, _g2[_p], n, t)
        };
      }
      d = d.parent;
    },
    _ret;
  for (; d;) {
    _ret = _loop2();
    if (_ret) return _ret.v;
  }
  return null;
}
function _e(l, a) {
  var e = l.editing.mapper,
    n = l.editing.view.domConverter,
    t = e.toViewElement(a);
  if (!t) return !0;
  var i = n.mapViewToDom(t);
  return f.window.getComputedStyle(i).float != "none";
}
function M(l, a, e, n) {
  var t = l.model;
  return t.createRange(t.createPositionAt(a, J(l, a, e, n)));
}
function J(l, a, e, n) {
  var t = l.editing.mapper,
    i = l.editing.view.domConverter,
    o = t.toViewElement(a),
    r = i.mapViewToDom(o),
    s = new k(r);
  return l.model.schema.isInline(a) ? e < (s.left + s.right) / 2 ? "before" : "after" : n < (s.top + s.bottom) / 2 ? "before" : "after";
}
function W(l, a) {
  var e = l.editing.mapper,
    n = l.editing.view,
    t = e.toModelElement(a);
  if (t) return t;
  var i = n.createPositionBefore(a),
    o = e.findMappedViewAncestor(i);
  return e.toModelElement(o);
}
function ke(l) {
  var a = l;
  do {
    a = a.parentElement;
    var e = f.window.getComputedStyle(a).overflowY;
    if (e == "auto" || e == "scroll") break;
  } while (a.tagName != "BODY");
  return a;
}
var ve = /*#__PURE__*/function (_ref16) {
  function ve() {
    var _this12;
    _classCallCheck(this, ve);
    _this12 = _callSuper(this, ve, arguments);
    m(_this12, "_isBlockDragging", !1);
    m(_this12, "_domEmitter", new (S())());
    return _this12;
  }
  _inherits(ve, _ref16);
  return _createClass(ve, [{
    key: "init",
    value: function init() {
      var _this13 = this;
      var e = this.editor;
      if (this.listenTo(e, "change:isReadOnly", function (n, t, i) {
        i ? (_this13.forceDisabled("readOnlyMode"), _this13._isBlockDragging = !1) : _this13.clearForceDisabled("readOnlyMode");
      }), b.isAndroid && this.forceDisabled("noAndroidSupport"), e.plugins.has("BlockToolbar")) {
        var t = e.plugins.get("BlockToolbar").buttonView.element;
        this._domEmitter.listenTo(t, "dragstart", function (i, o) {
          return _this13._handleBlockDragStart(o);
        }), this._domEmitter.listenTo(f.document, "dragover", function (i, o) {
          return _this13._handleBlockDragging(o);
        }), this._domEmitter.listenTo(f.document, "drop", function (i, o) {
          return _this13._handleBlockDragging(o);
        }), this._domEmitter.listenTo(f.document, "dragend", function () {
          return _this13._handleBlockDragEnd();
        }, {
          useCapture: !0
        }), this.isEnabled && t.setAttribute("draggable", "true"), this.on("change:isEnabled", function (i, o, r) {
          t.setAttribute("draggable", r ? "true" : "false");
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this._domEmitter.stopListening(), _superPropGet(ve, "destroy", this, 3)([]);
    }
  }, {
    key: "_handleBlockDragStart",
    value: function _handleBlockDragStart(e) {
      if (!this.isEnabled) return;
      var n = this.editor.model,
        t = n.document.selection,
        i = this.editor.editing.view,
        o = Array.from(t.getSelectedBlocks()),
        r = n.createRange(n.createPositionBefore(o[0]), n.createPositionAfter(o[o.length - 1]));
      n.change(function (s) {
        return s.setSelection(r);
      }), this._isBlockDragging = !0, i.focus(), i.getObserver(D).onDomEvent(e);
    }
  }, {
    key: "_handleBlockDragging",
    value: function _handleBlockDragging(e) {
      if (!this.isEnabled || !this._isBlockDragging) return;
      var n = e.clientX + (this.editor.locale.contentLanguageDirection == "ltr" ? 100 : -100),
        t = e.clientY,
        i = document.elementFromPoint(n, t),
        o = this.editor.editing.view;
      !i || !i.closest(".ck-editor__editable") || o.getObserver(D).onDomEvent(_objectSpread(_objectSpread({}, e), {}, {
        type: e.type,
        dataTransfer: e.dataTransfer,
        target: i,
        clientX: n,
        clientY: t,
        preventDefault: function preventDefault() {
          return e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
          return e.stopPropagation();
        }
      }));
    }
  }, {
    key: "_handleBlockDragEnd",
    value: function _handleBlockDragEnd() {
      this._isBlockDragging = !1;
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "DragDropBlockToolbar";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(_);
var ye = /*#__PURE__*/function (_ref17) {
  function ye() {
    var _this14;
    _classCallCheck(this, ye);
    _this14 = _callSuper(this, ye, arguments);
    m(_this14, "_draggedRange");
    m(_this14, "_draggingUid");
    m(_this14, "_draggableElement");
    m(_this14, "_clearDraggableAttributesDelayed", K(function () {
      return _this14._clearDraggableAttributes();
    }, 40));
    m(_this14, "_blockMode", !1);
    m(_this14, "_domEmitter", new (S())());
    m(_this14, "_previewContainer");
    return _this14;
  }
  _inherits(ye, _ref17);
  return _createClass(ye, [{
    key: "init",
    value: function init() {
      var _this15 = this;
      var e = this.editor,
        n = e.editing.view;
      this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, n.addObserver(D), n.addObserver(ae), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDraggableAttributeHandling(), this.listenTo(e, "change:isReadOnly", function (t, i, o) {
        o ? _this15.forceDisabled("readOnlyMode") : _this15.clearForceDisabled("readOnlyMode");
      }), this.on("change:isEnabled", function (t, i, o) {
        o || _this15._finalizeDragging(!1);
      }), b.isAndroid && this.forceDisabled("noAndroidSupport");
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._previewContainer && this._previewContainer.remove(), this._domEmitter.stopListening(), this._clearDraggableAttributesDelayed.cancel(), _superPropGet(ye, "destroy", this, 3)([]);
    }
  }, {
    key: "_setupDragging",
    value: function _setupDragging() {
      var _this16 = this;
      var e = this.editor,
        n = e.model,
        t = e.editing.view,
        i = t.document,
        o = e.plugins.get(C);
      this.listenTo(i, "dragstart", function (r, s) {
        var v;
        if ((v = s.target) != null && v.is("editableElement")) {
          s.preventDefault();
          return;
        }
        if (_this16._prepareDraggedRange(s.target), !_this16._draggedRange) {
          s.preventDefault();
          return;
        }
        _this16._draggingUid = H(), s.dataTransfer.effectAllowed = _this16.isEnabled ? "copyMove" : "copy", s.dataTransfer.setData("application/ckeditor5-dragging-uid", _this16._draggingUid);
        var c = n.createSelection(_this16._draggedRange.toRange());
        _this16.editor.plugins.get("ClipboardPipeline")._fireOutputTransformationEvent(s.dataTransfer, c, "dragstart");
        var g = s.dataTransfer,
          p = s.domTarget,
          h = s.domEvent,
          u = h.clientX;
        _this16._updatePreview({
          dataTransfer: g,
          domTarget: p,
          clientX: u
        }), s.stopPropagation(), _this16.isEnabled || (_this16._draggedRange.detach(), _this16._draggedRange = null, _this16._draggingUid = "");
      }, {
        priority: "low"
      }), this.listenTo(i, "dragend", function (r, s) {
        _this16._finalizeDragging(!s.dataTransfer.isCanceled && s.dataTransfer.dropEffect == "move");
      }, {
        priority: "low"
      }), this._domEmitter.listenTo(f.document, "dragend", function () {
        _this16._blockMode = !1;
      }, {
        useCapture: !0
      }), this.listenTo(i, "dragenter", function () {
        _this16.isEnabled && t.focus();
      }), this.listenTo(i, "dragleave", function () {
        o.removeDropMarkerDelayed();
      }), this.listenTo(i, "dragging", function (r, s) {
        if (!_this16.isEnabled) {
          s.dataTransfer.dropEffect = "none";
          return;
        }
        var _s$domEvent = s.domEvent,
          c = _s$domEvent.clientX,
          d = _s$domEvent.clientY;
        o.updateDropMarker(s.target, s.targetRanges, c, d, _this16._blockMode, _this16._draggedRange), _this16._draggedRange || (s.dataTransfer.dropEffect = "copy"), b.isGecko || (s.dataTransfer.effectAllowed == "copy" ? s.dataTransfer.dropEffect = "copy" : ["all", "copyMove"].includes(s.dataTransfer.effectAllowed) && (s.dataTransfer.dropEffect = "move")), r.stop();
      }, {
        priority: "low"
      });
    }
  }, {
    key: "_setupClipboardInputIntegration",
    value: function _setupClipboardInputIntegration() {
      var _this17 = this;
      var e = this.editor,
        t = e.editing.view.document,
        i = e.plugins.get(C);
      this.listenTo(t, "clipboardInput", function (o, r) {
        if (r.method != "drop") return;
        var _r$domEvent = r.domEvent,
          s = _r$domEvent.clientX,
          c = _r$domEvent.clientY,
          d = i.getFinalDropRange(r.target, r.targetRanges, s, c, _this17._blockMode, _this17._draggedRange);
        if (!d) {
          _this17._finalizeDragging(!1), o.stop();
          return;
        }
        if (_this17._draggedRange && _this17._draggingUid != r.dataTransfer.getData("application/ckeditor5-dragging-uid") && (_this17._draggedRange.detach(), _this17._draggedRange = null, _this17._draggingUid = ""), q(r.dataTransfer) == "move" && _this17._draggedRange && _this17._draggedRange.containsRange(d, !0)) {
          _this17._finalizeDragging(!1), o.stop();
          return;
        }
        r.targetRanges = [e.editing.mapper.toViewRange(d)];
      }, {
        priority: "high"
      });
    }
  }, {
    key: "_setupContentInsertionIntegration",
    value: function _setupContentInsertionIntegration() {
      var _this18 = this;
      var e = this.editor.plugins.get(T);
      e.on("contentInsertion", function (n, t) {
        if (!_this18.isEnabled || t.method !== "drop") return;
        var i = t.targetRanges.map(function (o) {
          return _this18.editor.editing.mapper.toModelRange(o);
        });
        _this18.editor.model.change(function (o) {
          return o.setSelection(i);
        });
      }, {
        priority: "high"
      }), e.on("contentInsertion", function (n, t) {
        if (!_this18.isEnabled || t.method !== "drop") return;
        var i = q(t.dataTransfer) == "move",
          o = !t.resultRange || !t.resultRange.isCollapsed;
        _this18._finalizeDragging(o && i);
      }, {
        priority: "lowest"
      });
    }
  }, {
    key: "_setupDraggableAttributeHandling",
    value: function _setupDraggableAttributeHandling() {
      var _this19 = this;
      var e = this.editor,
        n = e.editing.view,
        t = n.document;
      this.listenTo(t, "mousedown", function (i, o) {
        if (b.isAndroid || !o) return;
        _this19._clearDraggableAttributesDelayed.cancel();
        var r = z(o.target);
        if (b.isBlink && !e.isReadOnly && !r && !t.selection.isCollapsed) {
          var s = t.selection.getSelectedElement();
          (!s || !y(s)) && (r = t.selection.editableElement);
        }
        r && (n.change(function (s) {
          s.setAttribute("draggable", "true", r);
        }), _this19._draggableElement = e.editing.mapper.toModelElement(r));
      }), this.listenTo(t, "mouseup", function () {
        b.isAndroid || _this19._clearDraggableAttributesDelayed();
      });
    }
  }, {
    key: "_clearDraggableAttributes",
    value: function _clearDraggableAttributes() {
      var _this20 = this;
      var e = this.editor.editing;
      e.view.change(function (n) {
        _this20._draggableElement && _this20._draggableElement.root.rootName != "$graveyard" && n.removeAttribute("draggable", e.mapper.toViewElement(_this20._draggableElement)), _this20._draggableElement = null;
      });
    }
  }, {
    key: "_finalizeDragging",
    value: function _finalizeDragging(e) {
      var _this21 = this;
      var n = this.editor,
        t = n.model;
      n.plugins.get(C).removeDropMarker(), this._clearDraggableAttributes(), n.plugins.has("WidgetToolbarRepository") && n.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop"), this._draggingUid = "", this._previewContainer && (this._previewContainer.remove(), this._previewContainer = void 0), this._draggedRange && (e && this.isEnabled && t.change(function (o) {
        var r = t.createSelection(_this21._draggedRange);
        t.deleteContent(r, {
          doNotAutoparagraph: !0
        });
        var s = r.getFirstPosition().parent;
        s.isEmpty && !t.schema.checkChild(s, "$text") && t.schema.checkChild(s, "paragraph") && o.insertElement("paragraph", s, 0);
      }), this._draggedRange.detach(), this._draggedRange = null);
    }
  }, {
    key: "_prepareDraggedRange",
    value: function _prepareDraggedRange(e) {
      var _this22 = this;
      var n = this.editor,
        t = n.model,
        i = t.document.selection,
        o = e ? z(e) : null;
      if (o) {
        var d = n.editing.mapper.toModelElement(o);
        this._draggedRange = w.fromRange(t.createRangeOn(d)), this._blockMode = t.schema.isBlock(d), n.plugins.has("WidgetToolbarRepository") && n.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
        return;
      }
      if (i.isCollapsed && !i.getFirstPosition().parent.isEmpty) return;
      var r = Array.from(i.getSelectedBlocks()),
        s = i.getFirstRange();
      if (r.length == 0) {
        this._draggedRange = w.fromRange(s);
        return;
      }
      var c = Q(t, r);
      if (r.length > 1) this._draggedRange = w.fromRange(c), this._blockMode = !0;else if (r.length == 1) {
        var _d2 = s.start.isTouching(c.start) && s.end.isTouching(c.end);
        this._draggedRange = w.fromRange(_d2 ? c : s), this._blockMode = _d2;
      }
      t.change(function (d) {
        return d.setSelection(_this22._draggedRange.toRange());
      });
    }
  }, {
    key: "_updatePreview",
    value: function _updatePreview(_ref18) {
      var e = _ref18.dataTransfer,
        n = _ref18.domTarget,
        t = _ref18.clientX;
      var i = this.editor.editing.view,
        o = i.document.selection.editableElement,
        r = i.domConverter.mapViewToDom(o),
        s = f.window.getComputedStyle(r);
      this._previewContainer ? this._previewContainer.firstElementChild && this._previewContainer.removeChild(this._previewContainer.firstElementChild) : (this._previewContainer = B(f.document, "div", {
        style: "position: fixed; left: -999999px;"
      }), f.document.body.appendChild(this._previewContainer));
      var c = new k(r);
      if (r.contains(n)) return;
      var d = parseFloat(s.paddingLeft),
        g = B(f.document, "div");
      g.className = "ck ck-content", g.style.width = s.width, g.style.paddingLeft = "".concat(c.left - t + d, "px"), b.isiOS && (g.style.backgroundColor = "white"), i.domConverter.setContentOf(g, e.getData("text/html")), e.setDragImage(g, 0, 0), this._previewContainer.appendChild(g);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "DragDrop";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [T, ge, C, ve];
    }
  }]);
}(_);
function q(l) {
  return b.isGecko ? l.dropEffect : ["all", "copyMove"].includes(l.effectAllowed) ? "move" : "copy";
}
function z(l) {
  if (l.is("editableElement")) return null;
  if (l.hasClass("ck-widget__selection-handle")) return l.findAncestor(y);
  if (y(l)) return l;
  var a = l.findAncestor(function (e) {
    return y(e) || e.is("editableElement");
  });
  return y(a) ? a : null;
}
function Q(l, a) {
  var e = a[0],
    n = a[a.length - 1],
    t = e.getCommonAncestor(n),
    i = l.createPositionBefore(e),
    o = l.createPositionAfter(n);
  if (t && t.is("element") && !l.schema.isLimit(t)) {
    var r = l.createRangeOn(t),
      s = i.isTouching(r.start),
      c = o.isTouching(r.end);
    if (s && c) return Q(l, [t]);
  }
  return l.createRange(i, o);
}
var De = /*#__PURE__*/function (_ref19) {
  function De() {
    _classCallCheck(this, De);
    return _callSuper(this, De, arguments);
  }
  _inherits(De, _ref19);
  return _createClass(De, [{
    key: "init",
    value: function init() {
      var a = this.editor,
        e = a.model,
        n = a.editing.view,
        t = e.document.selection;
      n.addObserver(D), a.plugins.get(T).on("contentInsertion", function (i, o) {
        Te(o.content, e) && e.change(function (r) {
          var s = Array.from(t.getAttributes()).filter(function (_ref20) {
            var _ref21 = _slicedToArray(_ref20, 1),
              d = _ref21[0];
            return e.schema.getAttributeProperties(d).isFormatting;
          });
          t.isCollapsed || e.deleteContent(t, {
            doNotAutoparagraph: !0
          }), s.push.apply(s, _toConsumableArray(t.getAttributes()));
          var c = r.createRangeIn(o.content);
          var _iterator9 = _createForOfIteratorHelper(c.getItems()),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var d = _step9.value;
              var _iterator0 = _createForOfIteratorHelper(s),
                _step0;
              try {
                for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
                  var g = _step0.value;
                  e.schema.checkAttribute(d, g[0]) && r.setAttribute(g[0], g[1], d);
                }
              } catch (err) {
                _iterator0.e(err);
              } finally {
                _iterator0.f();
              }
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        });
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "PastePlainText";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [T];
    }
  }]);
}(_);
function Te(l, a) {
  var e = a.createRangeIn(l);
  if (l.childCount == 1) {
    var n = l.getChild(0);
    n.is("element") && a.schema.isBlock(n) && !a.schema.isObject(n) && !a.schema.isLimit(n) && (e = a.createRangeIn(n));
  }
  var _iterator1 = _createForOfIteratorHelper(e.getItems()),
    _step1;
  try {
    for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
      var _n = _step1.value;
      if (!a.schema.isInline(_n) || Array.from(_n.getAttributeKeys()).find(function (i) {
        return a.schema.getAttributeProperties(i).isFormatting;
      })) return !1;
    }
  } catch (err) {
    _iterator1.e(err);
  } finally {
    _iterator1.f();
  }
  return !0;
}
var Oe = /*#__PURE__*/function (_ref22) {
  function Oe() {
    _classCallCheck(this, Oe);
    return _callSuper(this, Oe, arguments);
  }
  _inherits(Oe, _ref22);
  return _createClass(Oe, [{
    key: "init",
    value: function init() {
      var a = this.editor,
        e = this.editor.t;
      a.accessibility.addKeystrokeInfos({
        keystrokes: [{
          label: e("Copy selected content"),
          keystroke: "CTRL+C"
        }, {
          label: e("Paste content"),
          keystroke: "CTRL+V"
        }, {
          label: e("Paste content as plain text"),
          keystroke: "CTRL+SHIFT+V"
        }]
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "Clipboard";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [Y, T, ye, De];
    }
  }]);
}(_);
export { Oe as Clipboard, Y as ClipboardMarkersUtils, D as ClipboardObserver, T as ClipboardPipeline, ye as DragDrop, ve as DragDropBlockToolbar, C as DragDropTarget, De as PastePlainText, ue as plainTextToHtml, G as viewToPlainText };